import * as Sentry from '@sentry/react';
import { useState, useEffect } from 'react';
import { ONBOARDING_ORIGIN_PARAM } from '../constants';
import { LoginVariantProps } from '../interfaces/loginVariant';
import { defaultVariant } from '../login-variants';
import { trackEvent } from '@do/seashell';
import { fetchLoginVariants } from '../utils/fetch-login-variants';
import { getQueryParam } from '../utils/query-utils';
import { useLocation } from '@do/seashell/navigation';
import { getLoginVariant } from '../utils/login-variant-utils';

export type LoginVariantsHookResponse = {
  variant: LoginVariantProps | null;
};

export type UseLoginLoginVariantProps = {
  onboardingOrigin: string;
};

export const useLoginVariants = (): LoginVariantsHookResponse => {
  const [loginVariant, setLoginVariant] = useState<LoginVariantProps | null>(null);
  const location = useLocation();
  const { search } = location;

  const onboardingOrigin = getQueryParam(ONBOARDING_ORIGIN_PARAM, search) || '';

  useEffect(() => {
    const fetchAndFindVariants = async () => {
      try {
        const data = await fetchLoginVariants();
        const selectedVariant = getLoginVariant(data, onboardingOrigin);
        setLoginVariant(selectedVariant);
        trackEvent('Login Variant', { variantType: selectedVariant.type });
      } catch (err) {
        Sentry.captureException(err);
        console.error('unable to load variants', err);
        trackEvent('Login Variant', { variantType: defaultVariant.type });
        setLoginVariant(defaultVariant);
      }
    };
    fetchAndFindVariants();
  }, [onboardingOrigin]);

  return {
    variant: loginVariant,
  };
};

export default useLoginVariants;
